<app-domestic-hot-water-panel *ngIf="dhw$ | async | ready"></app-domestic-hot-water-panel>
<app-recirculation-settings> </app-recirculation-settings>
